import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isPhone(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.PHONE && typeof label === 'string' && typeof value === 'string';
}
function _formatPhone(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatPhone(submission) {
  if (isPhone(submission)) {
    return _formatPhone(submission);
  }
  return undefined;
}
//# sourceMappingURL=phone-preview.js.map